import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Remove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail2Remove"><Path d="M12 19.5H2.5V4.5H21.5L21.5 7.25L12 12.0714L2.73768 7.37063" stroke="currentColor"/><Path d="M16.25 20.25L19.25 17.25M19.25 17.25L22.25 14.25M19.25 17.25L16.25 14.25M19.25 17.25L22.25 20.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconEmail2Remove;
